import { render } from "./HorizontalCompact.vue?vue&type=template&id=efc5960e&scoped=true"
import script from "./HorizontalCompact.vue?vue&type=script&lang=js"
export * from "./HorizontalCompact.vue?vue&type=script&lang=js"

import "./HorizontalCompact.vue?vue&type=style&index=0&id=efc5960e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efc5960e"]])

export default __exports__